import { useEffect, useRef, useState } from 'react';
import styles from './ImplantImageComponent.module.css';
import ModalLayout from '../../general/modal/ModalLayout';
import FileModal from '../../video-overview/FileModal';
import { UserFile } from '../../files/FilesOverviewPage';

const ImplantImageComponent: React.FC<{ name?: string; file?: UserFile }> = ({
    name,
    file,
}) => {
    const imgRef = useRef(null);
    const [style, setStyle] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (imgRef.current) {
            const { width, height } = imgRef.current.getBoundingClientRect();
            if (width > height) {
                setStyle({ height: '100%' });
            } else {
                setStyle({ width: '100%' });
            }
        }
    }, []);

    const handleImageClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className={styles.container}>
            {!file && (
                <img
                    style={style}
                    ref={imgRef}
                    src={'https://files.nordinsight.com/implant-images/' + name}
                    className={styles.image}
                    alt=""
                    onClick={handleImageClick}
                />
            )}
            {file && (
                <img
                    style={style}
                    ref={imgRef}
                    src={file.url}
                    className={styles.image}
                    alt=""
                    onClick={handleImageClick}
                />
            )}
            {isModalOpen && (
                <>
                    {!file && (
                        <ModalLayout
                            onClose={handleCloseModal}
                            hasCloseButton={true}
                            size="large"
                        >
                            <img
                                src={
                                    'https://files.nordinsight.com/implant-images/' +
                                    name
                                }
                                alt=""
                                style={{ width: '50vw', height: 'auto' }}
                            />
                        </ModalLayout>
                    )}
                    {file && (
                        <FileModal
                            file={{ ...file, title: file.filename }}
                            close={handleCloseModal}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default ImplantImageComponent;
